'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _ApiClient = require('./ApiClient');

var _ApiClient2 = _interopRequireDefault(_ApiClient);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Class for the Claim API
 */
var CoveApi = function () {
  /**
   * Intialises a new API Client
   * @param {string} host
   * @param {string} path
   * @param {string} environment
   * @param {{accessToken: string, apiKey: string, refreshInterval: number}} auth
   */
  function CoveApi(host, path, environment, auth) {
    (0, _classCallCheck3.default)(this, CoveApi);

    this.apiClient = new _ApiClient2.default(host, path, environment, auth);
  }

  (0, _createClass3.default)(CoveApi, [{
    key: 'useLocalToken',
    value: function useLocalToken() {
      var accessToken = localStorage.getItem('cove-access-token');
      if (accessToken) {
        this.apiClient.accessToken = accessToken;
      }
      return this;
    }
  }, {
    key: 'accessToken',
    get: function get() {
      return this.apiClient.accessToken;
    },
    set: function set(token) {
      this.apiClient.accessToken = token;
    }
  }]);
  return CoveApi;
}();

exports.default = CoveApi;